import request from '@/utils/request'

/**
 * 获取素材库列表
 * @returns
 */
export function getMaterialLibraryList(params = {}) {
  return request({
    url: '/material_center/list',
    method: 'get',
    params
  })
}

export function uploadadd(data = {}) {
  return request({
    url: '/material_center/store',
    method: 'post',
    data
  })
}
//

export function upload(data = {}) {
  return request({
    url: '/material_center/upload',
    method: 'post',
    data,
    headers: {
      'Content-type': 'multipart/form-data'
    }
  })
}
